import { accountBadgeEntityName, accountBadgeFrontImageAttachmentKey } from '../../../../../backend/features/badges/shared';
import { stopEventPropagation } from '../../../../../ui/features/badge-management/utils/stopEventPropagationHandler';
import { showAccountBadgePreviewModal } from '../../../../../ui/features/badge-preview/utils/showAccountBadgePreviewModal';
import { TextCell } from '@juvare/common-data-table-ui/DataTable';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Image } from '@juvare/platform-sdk-react/ui/components';
import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
export const AccountBadgeNameCell = ({ accountBadge, descriptionContent }) => {
    const handlePreviewClick = () => {
        showAccountBadgePreviewModal(accountBadge);
    };
    return (React.createElement(TextCell, null,
        React.createElement(Stack, { direction: 'row', gap: 2 },
            React.createElement(Box, { sx: {
                    width: '82px',
                    height: '52px',
                    borderWidth: 1,
                    borderStyle: 'solid',
                    overflow: 'hidden',
                    borderRadius: 1,
                    borderColor: themeColors.border.main,
                    cursor: 'pointer',
                }, onClick: stopEventPropagation(handlePreviewClick) },
                React.createElement(Image, { entity: accountBadgeEntityName, entityId: accountBadge.id, attachmentKey: accountBadgeFrontImageAttachmentKey, sx: { width: '100%' } })),
            React.createElement(Stack, null,
                React.createElement(Typography, { variant: 'h6', sx: { wordBreak: 'break-word' } }, accountBadge.columns.accountDisplayName),
                React.createElement(Stack, { direction: 'row', gap: 1, alignItems: 'center' }, descriptionContent)))));
};
